import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter, useHistory } from 'react-router-dom';
import { toast, cssTransition } from "react-toastify";
import {
  loginUser,
  sendOTP,
  validateOTP,
  // loadConfigs,
  checkOTP,
  userAssign
} from "../../../store/actions/authActionCreators";
import OtpInput from "react-otp-input";
import FormControl from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { loginEvent } from '../../../analytics';
import Paper from '@material-ui/core/Paper';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Divider from '@material-ui/core/Divider';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import CallIcon from '@material-ui/icons/Call';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Timer from 'react-compound-timer';
import { Dialog, DialogActions } from "@material-ui/core";
import Link from '@material-ui/core/Link';
import dialogStyles from "./modal";
import "./otp-input.css";
import { MobileIcon } from '../../../components/icons';
import { checkScreen } from '../../../utils/utils';
import * as logger from "../../../logger";
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import CloseIcon from '@material-ui/icons/Close';
import { trackDwebEvent, loginDwebEvent, logoutDwebEvent } from '../../analytics';
import {
  getSubscriptionPlans, paySubscriptionAction, getSubscriptionStatus,
  updateFreeTrialModal
} from "../../../store/actions/paymentsActionCreator";
import SimpleKhataLoginDialog from "../Dialog/SimpleKhataLoginDialog";
//Styling used.
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  sendOTP: {
    //marginTop: theme.spacing(3),
    height: '56px',
    backgroundColor: '#011627',
    color: 'white',
    width: '100%',
    marginBottom: theme.spacing(3),
  },
  textField: {
    width: "25ch",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  paper1: {
    backgroundColor: '#ff8966',
    height: '100vh',
  },
  paper2: {
    backgroundColor: '#ff9f1c',
    height: '100vh',
  },
  form1: {
    height: 'inherit',
  },
  formControl: {
    width: '100%',
    height: '100%',
  },
  divV1: {
    paddingRight: '24px',
    paddingLeft: '24px',
  },
  divV2: {
    fontFamily: 'Roboto',
    fontSize: '24px',
    fontWeight: '500',
    marginTop: '24px',
  },
  divV3: {
    fontSize: '11px',
    fontFamily: 'Roboto',
    marginTop: '8px',
  },
  divV4: {
    display: 'flex',
    marginRight: '8px',
    marginLeft: '8px',
    alignItems: 'flex-end',
    height: '100%',
    marginBottom: '80px',
  },
  divV5: {
    color: '#011627',
    fontSize: '24px',
    fontWeight: 500,
    fontFamily: 'Roboto',
    marginLeft: '24px',
    marginTop: '24px',
  },
  divV6: {
    marginLeft: '24px',
    fontSize: '11px',
    fontFamily: 'Roboto',
  },
  divV7: {
    marginTop: '24px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  divV8: {
    color: '#0033cc',
    cursor: 'pointer',
  },
  divV9: {
    textAlign: 'end',
    marginRight: '30px',
    fontSize: '11px',
    color: '#0033cc',
    cursor: 'pointer',
    fontFamily: 'Roboto',
  },
  divV10: {
    display: 'flex',
    marginRight: '8px',
    marginLeft: '8px',
    alignItems: 'center',
    height: '100%',
    paddingBottom: '80px',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    overflow: 'hidden',
  },
  divV11: {
    marginLeft: '18px',
    fontSize: '11px',
    marginRight: '18px',
    textAlign: 'center'

  },
  divV12: {
    textAlign: 'center',
    height: '110px',
    backgroundColor: 'white',
    width: '100%',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  divV13: {
    fontSize: '11px',
    fontFamily: 'Roboto',
    marginBottom: '14px',
  },
  divV14: {
    marginLeft: '24px',
    fontSize: '11px',
    marginTop: '8px',
  },
  divV15: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '15px',
  },
  divV16: {
    marginTop: '16px',
    marginBottom: '8px',
    width: '97%',
    height: '56px',
    backgroundColor: '#011627',
    color: 'white',
    fontWeight: '500',
    fontSize: '16px',
    fontFamily: 'Roboto',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  divV17: {
    display: 'flex',
    justifyContent: 'center',
  },
  iconButtonBack: {
    backgroundColor: 'white',
    color: '#ff8966',
    marginTop: '52px',
    height: '32px',
    width: '32px',
    outline: '0',
  },
  iconButtonBack1: {
    backgroundColor: 'white',
    color: '#ff8966',
    marginTop: '52px',
    height: '32px',
    width: '32px',
    outline: '0',
    marginLeft: '24px',
  },
  arrowIcon: {
    outline: '0',
    height: '24px',
    width: '24px',
  },
  oulinedInput: {
    backgroundColor: 'white',
    width: '100%',
    height: '48px',
    borderRadius: '8px',
    marginTop: '8px',
    paddingLeft: '15px',
  },
  inputAdornImg: {
    color: 'white',
    backgroundColor: 'white',
    fill: 'none',
    marginRight: '12px',
    marginTop: '0.35em'
  },
  inputAdornDivider: {
    height: '32px',
    margin: '4px',
  },
  spanV1: {
    fontSize: '16px',
    fontWeight: '500',
    outline: '0',
    fontFamily: 'Roboto',
  },
  color1: {
    color: 'white',
  },
  color2: {
    color: '#011627',
  },
  pointer1: {
    cursor: 'pointer',
  },
  button1: {
    marginTop: theme.spacing(3),
    marginRight: '8px',
    marginLeft: '8px',
    height: '56px',
    width: '100%',
    backgroundColor: '#011627 !important',
    color: 'white !important',
    marginTop: '8px',
    marginBottom: 20
  },
  button2: {
    marginTop: '16px',
    width: '100%',
    height: '56px',
    backgroundColor: '#011627',
    color: 'white',
    fontWeight: '500',
    fontSize: '16px',
    fontFamily: 'Roboto',
    borderRadius: '8px',
    textTransform: 'none',
  },
  w1: {
    width: '100%',
  },
  pV1: {
    marginTop: 10,
    marginLeft: 15,
    color: "red",
  },
  mt1: {
    marginTop: '2px',
    color: 'white',
  },
  otpError: {
    width: 'inherit',
    height: '48px',
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.87)',
    marginLeft: '8px',
    marginRight: '8px',
    marginTop: '40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  otpSuccess: {
    width: 'inherit',
    height: '48px',
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.87)',
    marginLeft: '8px',
    marginRight: '8px',
    marginTop: '40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  font1: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    marginLeft: '16px'
  },
  dialogWrapper: {
    alignSelf: 'flex-end',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    margin: '0',
    boxShadow: '0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)',
    width: '100%',
    [theme.breakpoints.only("md")]: {
      minWidth: '1024px',
    },
  },
  cancel: {
    marginLeft: '16px',
    width: '24px',
    height: '24px',
    color: 'red'
  },
  tick: {
    marginLeft: '16px',
    width: '24px',
    height: '24px',
    color: 'white'
  },
  da1: {
    paddingBottom: '0px !important'
  },
  appBar: {
    backgroundColor: "#ff8966",
    top: "auto",
    bottom: 0,
    right: "auto",
    zIndex: 999,
    boxShadow: 'none'
  },
  toolbar: {
    backgroundColor: "#ff8966",
    paddingLeft: 8,
    paddingRight: 8
  },
}));

const toastStyles = makeStyles((theme) => ({
  divV1: {
    display: 'flex', height: '100%',
  },
  divToastError: {
    width: '3%', backgroundColor: 'red',
  },
  divV2: {
    display: 'flex', alignItems: 'center', paddingBottom: 10, paddingTop: 10, marginLeft: 15
  },
  closeIconV1: {
    color: 'red'
  },
  divTitle: {
    fontSize: 20, fontWeight: 300, letterSpacing: "1px"
  },
  divMessage: {
    fontSize: 16, fontWeight: 'normal', color: '#505050'
  },
  mlV1: {
    marginLeft: 10
  },
  divToastSuccess: {
    width: '3%', backgroundColor: '#00875a'
  },
  done: {
    color: '#00875a', fontSize: 40
  }
}));

function SuccessToastMessage({ message, closeToast }) {
  const classes = toastStyles();

  return <div className={classes.divV1}>
    <div className={classes.divToastSuccess}>&nbsp;</div>
    <div className={classes.divV2}>
      <div>
        <CheckCircleOutlinedIcon className={classes.done} />
      </div>
      <div className={classes.mlV1}>
        <div className={classes.divTitle}>
          Success
        </div>
        <div className={classes.divMessage}>
          {message}
        </div>
      </div>
    </div>
  </div>
}

function ErrorToastMessage({ message, closeToast }) {
  const classes = useStyles();

  return <div className={classes.divV1}>
    <div className={classes.divToastError}>&nbsp;</div>
    <div className={classes.divV2}>
      <div>
        <CloseIcon classname={classes.closeIconV1} />
      </div>
      <div className={classes.mlV1}>
        <div className={classes.divTitle}>
          Failed
        </div>
        <div className={classes.divMessage}>
          {message}
        </div>
      </div>
    </div>
  </div>
}

const SignInForm = ({ dispatchLoginAction, dispatchGetSubscriptionStatusAction, dispatchValidateOtpAction, dispatchCheckOtp, dispatchAssignUser }) => {
  //Assign styles to classes.
  const classes = useStyles();
  const toastClasses = toastStyles();
  const history = useHistory();

  //State variables.
  const [mobileNumber, setMobileNumber] = useState("");
  const [numInputs, setNumInputs] = useState(4);
  const [separator, setSeparator] = useState("--");
  const [isDisabled, setIsDisabled] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [hasNoError, setHasNoError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isInputNum, setIsInputNum] = useState(true);
  const [minLength, setMinLength] = useState(0);
  const [maxLength, setMaxLength] = useState(10);
  const [otpSent, setOtpSent] = useState(false);
  const [error, setError] = useState({ mobileNumber: false });
  const [OTP, setOTP] = useState("");
  const [timerFlag, setTimerFlag] = useState(true);
  const [userInfo, setUserInfo] = useState(null);
  const [show, setShow] = useState(false);
  const [mobileScreen, setMobileScreen] = useState();
  const [desktopScreen, setDesktopScreen] = useState();
  const modalClasses = dialogStyles();
  const [arrow, setArrowFlag] = useState(true);
  const [numberFormatted, setNumber] = useState();
  const [simpleKhataDialog, setSimpleKhataDialog] = useState(false)

  const Zoom = cssTransition({
    enter: 'fadeInn',
    exit: 'fadeOutt',
    duration: 500
  });


  //Called on clicking Get OTP.
  const handleOnSubmit = (event) => {
    event.preventDefault();
    if (isFormInvalid()) updateErrorFlags();
    else {
      dispatchLoginAction(
        mobileNumber,
        (data) => {
          if (data && data.status && data.status.code === 200) {
            setOtpSent(true);
            setTimerFlag(false);
            toast.success(<SuccessToastMessage message={"Otp Sent Successfully"} />,
              {
                className: 'toastContainer',
                closeOnClick: true,
                closeButton: true,
                pauseOnHover: false,
              }
            );
          }
        },
        (data) => {


            logger.log("Login", 'Error', data);

          // toast.error(`Error: ${data.status.message}`,
          // {
          //   className: 'toastContainer',
          //   closeOnClick: false,
          //   closeButton: false,
          //   transition: Zoom,
          //   pauseOnHover: false,
          // }
          // );
        }
      );
    }
  };

  const handleCancelForm = (event) => {
    event.preventDefault();
    setMobileNumber("");
    setError({ mobileNumber: false });
  };

  const handleOnOtpChange = (e) => {
    let currVal = e.target.value;

    if (e.target.name === "numInputs") {
      const { minLength, maxLength } = this.state;

      if (currVal < minLength || currVal > maxLength) {
        currVal = 4;

        console.error(
          `Please enter a value between ${minLength} and ${maxLength}`
        );
      }
    }

    this.setState({ [e.target.name]: currVal });
  };

  const isFormInvalid = () => !mobileNumber;
  const gotoMain = () => {
    history.push({
      pathname: '/',
      state: {
        id: 7,
        pageTitle: 'Dashboard'
      }
    });
  }
  const goto500 = () => {
    history.push({
      pathname: '/500'
    });
  }
  const gotoParties = () => {
    history.push({
      pathname:'/parties',
      state: {
        id: 1,
        pageTitle: 'Parties'
      }
    });
  }
  
  const goToPremium = (data) => {
    const userInfoLocalStorage = JSON.parse(localStorage.getItem('USER_INFO'));
    // if ((userInfo && userInfo.role && userInfo.role != "USER") || (userInfoLocalStorage && userInfoLocalStorage.userInfo && userInfoLocalStorage.userInfo.role != "USER")) {
    history.push({
      pathname: `/payments`,
      state: {
        id: 1,
        pageTitle: 'Premium'
      }
    });
    // }
  }
  
  //Called when OTP is entered in input.
  const handleCheckOtp = (otp) => {
    setOTP(otp);
    logger.log("Login", "the otp is", OTP);
    if (otp.length === 4) {
      setArrowFlag(false);
      dispatchCheckOtp(
        mobileNumber,
        otp,
        (data) => {
          logger.log("Login", "the response is", data);
          if (data && data.status && data.status.code === 200) {
            setUserInfo(data);
            loginDwebEvent(data.response.user);

            trackDwebEvent("Login Successfully")
            setHasNoError(true);
            setHasError(false);
            setTimeout(() => {
              if (
                data &&
                data.response &&
                data.response.token &&
                data.response.user
              ) {
                let userInfo = data.response.user;
                if (data.response.user.companyName) {
                  toast.success(
                    <SuccessToastMessage message={"Logged In Successfully!"} />,
                    {
                      className: 'toastContainer',
                      closeOnClick: true,
                      closeButton: true,
                      // transition: Zoom,
                      pauseOnHover: false,
                      position: localStorage.getItem("CheckTripOverlay") === null ? "bottom-right" : "top-right",
                    }
                  );
                }
                dispatchAssignUser(
                  data
                );
                //dispatchLoadConfigs();
                // dispatchLoadConfigs((data) => {
                //   if (data && data.status && data.status.code === 200) {
                //     let config = data.response;
                //     let pre = config && config.subscription && config.subscription.enabled && config.subscription.enabled === 1 ? true : false;
                //     if (pre) {
                //       dispatchGetSubscriptionStatusAction(
                //         (res) => {
                //           if (res && res.status && res.status.code === 200 && res.response) {
                //             let status = res.response;
                //             if (
                //               (status && typeof status.isExpired != 'undefined' && status.isExpired) ||
                //               (userInfo && typeof userInfo.isSubscriptionActive != 'undefined' && !userInfo.isSubscriptionActive)
                //             ) {
                //               if (userInfo.role !== "USER") {
                //                 goToPremium()
                //               }
                //             } else {
                //               gotoMain()
                //             }
                //           }
                //         },
                //         () => {
                //         })
                //     } else {
                //       gotoMain()
                //     }
                //   }
                // }, () => {
                //   gotoParties();
                // });
              }
            }, 500);
          }
          else if (data && data.status && data.status.code === 500) {
            setHasError(true);
            setHasNoError(false);
          } else if (data && data.status && data.status.code === 400) {
            setHasError(true);
            setHasNoError(false);
          } else if (data && data.status && data.status.code == 465) {
            
            setNumber(null);
            setHasNoError(true);
            setHasError(false);
            setOtpSent(false);
            setOTP("");
            setSimpleKhataDialog(true);
            setTimerFlag(false);

          } else {
            // toast.error(
            //   <ErrorToastMessage message={"Unable to Login"} />,
            //   {
            //     className: 'toastContainer',
            //     closeOnClick: true,
            //     closeButton: true,
            //     // transition: Zoom,
            //     pauseOnHover: false,
            //   }
            // );
            logger.log("unable to login")

          }
        },

        (message) => {
          // toast.error();
        }
      );
    }
  };

  const handleConfirm = (event) => {
    event.preventDefault();
    handleCheckOtp(OTP);
  }

  const updateErrorFlags = () => {
    const errObj = { mobileNumber: false };
    if (!mobileNumber.trim()) errObj.mobileNumber = true;
    setError(errObj);
  };

  //Removing dash from input mobile number.
  const removeDash = (number) => {
    if (number != null) {
      setMobileNumber(number.replace(/-/g, ""));
    }
  }

  //Adding dash between input mobile number. 
  const addDash = (number) => {

    let n = number.replace(/-/g, "");
    let n1 = n.slice(0, 5);
    let n2 = n.slice(5);

    if (n2) {
      setNumber([n1, n2].join('-'));
    }
    else {
      setNumber(n1);
    }
  }

  //Navigating back to login page.
  const goBack = () => {
    setOtpSent(false);
  }

  //Verifying screen size.
  const checkScreens = () => {
    let screens = checkScreen();
    setMobileScreen(screens.mobile);
    setDesktopScreen(screens.desktop);
  }

  const handleCloseKhataDialog = () => {
    setSimpleKhataDialog(false);
  }

  return (
    <>
      {!otpSent && (
        <Paper className={classes.paper1}>
          <form name="signUp" noValidate onSubmit={handleOnSubmit} className={classes.form1}>
            <FormControl className={classes.formControl}>
              <div className={classes.divV1}>
                {otpSent == true &&
                  <IconButton aria-label="back" className={classes.iconButtonBack}>
                    <ArrowBackIcon fontSize="small" className={classes.arrowIcon} />
                  </IconButton>
                }
                <div className={(mobileNumber.length == 10) ? [classes.color2] : [classes.color1]}>
                  <div htmlFor="mobileNumber" className={classes.divV2}>Your Mobile Number</div>
                </div>
                <OutlinedInput
                  className={classes.oulinedInput}
                  placeholder="Enter Mobile Number"
                  id="mobileNumber"
                  value={numberFormatted}
                  onChange={(e) => {
                    removeDash(e.target.value);
                    addDash(e.target.value);
                  }}
                  startAdornment={
                    <InputAdornment position="end">
                      <MobileIcon className={classes.inputAdornImg}>
                      </MobileIcon>
                      +91 <Divider className={classes.inputAdornDivider} orientation="vertical" /></InputAdornment>
                  }
                />
                <div className={(mobileNumber.length == 10) ? [classes.color2] : [classes.color1]}>
                  <div className={classes.divV3}>We will be sending an OTP to verify mobile number</div>
                </div>
              </div>

              {/* Checking the length of mobile number entered and rendering the button. */}
              {/* {(mobileNumber.length === 10) &&
                <div className={classes.divV4}>
                  <Button
                    type="submit"
                    variant="contained"
                    className={classes.sendOTP}
                  >
                    <span className={classes.spanV1}>
                      Get OTP
                  </span>
                  </Button>
                </div>
              } */}
            </FormControl>
            {(mobileNumber.length === 10) && <AppBar
              position="fixed"
              color="primary"
              className={classes.appBar}
            >
              <Toolbar className={classes.toolbar}>
                <Button
                  type="submit"
                  className={classes.sendOTP}
                >
                  Get OTP
                </Button>
              </Toolbar>
            </AppBar>}
          </form>
        </Paper>
      )}
      {otpSent && (
        <Paper className={classes.paper1}>
          <form noValidate className={classes.form1} >
            <FormControl className={classes.formControl}>
              <div>
                {hasError &&
                  <div>
                    <div className={classes.otpError}><div className={classes.font1}>OTP Error</div></div>
                  </div>
                }
                {hasNoError &&
                  <div>
                    <div className={classes.otpSuccess}><div className={classes.font1}>OTP Successfull</div></div>
                  </div>
                }
              </div>
              <section>
                <div>
                  {arrow &&
                    <IconButton aria-label="back" className={classes.iconButtonBack1} onClick={goBack}>
                      <ArrowBackIcon fontSize="small" className={classes.arrowIcon} />
                    </IconButton>
                  }
                </div>
                <div className={classes.divV5}>One Time Password (OTP)</div>
                <div className={classes.divV15}>
                  <OtpInput
                    inputStyle="inputStyle"
                    numInputs={numInputs}
                    isDisabled={isDisabled}
                    hasErrored={hasError}
                    errorStyle="error"
                    onChange={handleCheckOtp}
                    isInputNum={isInputNum}
                    shouldAutoFocus
                    value={OTP}
                  />
                  {hasError &&
                    <CancelIcon className={classes.cancel} />
                  }
                  {hasNoError &&
                    <CheckCircleIcon className={classes.tick} />
                  }
                </div>
                <div className={classes.divV14}>Please enter the 4-digit code sent to you at {numberFormatted}</div>
              </section>
              <div className={classes.divV7}>
                <div className={classes.divV6}>
                  {timerFlag === true ? <div className={classes.divV8} onClick={handleOnSubmit}><u>Resend OTP</u></div> :
                    <Timer
                      initialTime={30000}
                      direction="backward"
                      startImmediately="true"
                      checkpoints={[
                        {
                          time: 0,
                          callback: () => setTimerFlag(true),
                        },
                      ]}
                    >
                      <>
                        <div className={classes.mt1}>
                          Resend OTP in 00.<Timer.Seconds />s
                        </div>
                      </>
                    </Timer>
                  }
                </div>
                <div className={classes.divV9} onClick={() => setShow(true)}><div><u>Get OTP on Call</u></div></div>
              </div>
              {/* <div className={classes.divV10}>
                <div className={classes.divV11}>By confirming OTP, you agree to our <Link href="https://www.transportbook.in/terms.html" target="_blank" className={classes.pointer1}><u>terms & conditions</u></Link></div>
                <Button
                  type="submit"
                  variant="contained"
                  classes={{ disabled: classes.button1, root: classes.button1 }}
                  onClick={handleConfirm}
                  disabled={OTP.length == 4 ? false : true}
                >
                  <span className={classes.spanV1}>
                    Confirm OTP
                  </span>
                </Button>
              </div> */}

              {/* On clicking get otp on call. */}
              <div className={classes.w1}>
                <Dialog open={show} onClose={() => setShow(false)} onEnter={checkScreens} classes={{ paper: classes.dialogWrapper }} className={modalClasses.modalResponsive1} style={{ textAlign: 'center' }}>
                  {mobileScreen && <DialogActions className={classes.da1}>
                    <Button className={classes.button2}><CallIcon />&nbsp;Call 07948059596</Button>
                  </DialogActions>}
                  {desktopScreen && <div className={classes.divV17}>
                    <div className={classes.divV16}><CallIcon />&nbsp;Call 07948059596</div>
                  </div>}
                  <div className={classes.divV13}>
                    Make sure you are calling from registering mobile number
                  </div>
                </Dialog>
              </div>
              <AppBar
                position="fixed"
                color="primary"
                className={classes.appBar}
              >
                <div className={classes.divV11}>By confirming OTP, you agree to our <Link href="https://www.transportbook.in/terms.html" target="_blank" className={classes.pointer1}><u>terms & conditions</u></Link></div>
                <Toolbar className={classes.toolbar}>
                  <Button
                    type="submit"
                    variant="contained"
                    classes={{ disabled: classes.button1, root: classes.button1 }}
                    onClick={handleConfirm}
                    disabled={OTP.length == 4 ? false : true}
                  >
                    <span className={classes.spanV1}>
                      Confirm OTP
                    </span>
                  </Button>
                </Toolbar>
              </AppBar>
            </FormControl>
          </form>
        </Paper>
      )}

      { simpleKhataDialog && <SimpleKhataLoginDialog open={simpleKhataDialog} 
      onClose={handleCloseKhataDialog} ></SimpleKhataLoginDialog> }
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  dispatchLoginAction: (mobileNumber, onSuccess, onError) =>
    dispatch(sendOTP({ mobileNumber }, onSuccess, onError)),
  dispatchValidateOtpAction: (mobileNumber, OTP, onSuccess, onError) =>
    dispatch(
      validateOTP({ number: mobileNumber, otp: OTP }, onSuccess, onError)
    ),
  dispatchCheckOtp: (mobileNumber, OTP, onSuccess, onError) =>
    dispatch(
      checkOTP({ number: mobileNumber, otp: OTP }, onSuccess, onError)
    ),
  dispatchAssignUser: (userInfo) =>
    dispatch(
      userAssign(userInfo)
    ),
  dispatchGetSubscriptionStatusAction: (onSuccess, onFailure) => {
    dispatch(getSubscriptionStatus(onSuccess, onFailure))
  },
  // dispatchLoadConfigs: (onSuccess, onError) => dispatch(loadConfigs(
  //   onSuccess,
  //   onError
  // )),
});
export default connect(null, mapDispatchToProps)(SignInForm);